function getQueryStringParameters() {
  var parameters = {}, hash;
  var q = document.URL.split('?')[1];
  if (q != undefined) {
    q = q.split('&');
    for (var i = 0; i < q.length; i++) {
      hash = q[i].split('=');
      parameters[hash[0]] = hash[1];
    }
  }
  return parameters;
}

function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key))
      return false;
  }
  return true;
}

/// Takes a list of query parmeters and a FormData,
/// and appends the parameters to the form
function populateCartAttributes(parameters, formData) {
  if (isEmpty(parameters) == false) {
    const entries = Object.entries(parameters);
    let data = entries.map(([key, val] = entry) => {
      // apend these to the cart attributes
      // janky, solve at root!
      val = val.replace(/%2F/gi, "/");
      formData.append('attributes[' + key + ']', val)
    });
  }
  return formData
}

function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName;

  for (let i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

function getUTMParams() {
  const utmParams = new URLSearchParams();
  const utmSource = sessionStorage.getItem("utm_source");
  const utmMedium = sessionStorage.getItem("utm_medium");
  const utmCampaign = sessionStorage.getItem("utm_campaign");

  if (utmSource) {
    utmParams.set("utm_source", utmSource)
  }
  if (utmMedium) {
    utmParams.set("utm_medium", utmMedium)
  }
  if (utmCampaign) {
    utmParams.set("utm_campaign", utmCampaign)
  }

  return utmParams;
}

/// Replaces the cart with the item in `config` (dropping cart attributes it
/// doesn't set), then goes to the cart or checkout. Adds first and prunes
/// second, so a failed add leaves the cart as it was (see replaceCartWith in
/// global.js). Rejects when the add fails; the caller shows the error.
async function clearCartAndCheckout(config, bypassCartPage) {
  try {
    await replaceCartWith(routes.cart_add_url, config, { clearOtherAttributes: true });
  } catch (error) {
    // The plan is already in the cart next to the old items: let the customer review it there.
    if (checkIsCartPruneError(error)) {
      window.location.href = routes.cart_url;
      return;
    }

    throw error;
  }

  const utmParams = getUTMParams();
  let cartUrl = bypassCartPage ? "/checkout" : "/cart";
  if (utmParams.size > 0) {
    cartUrl += `?${utmParams.toString()}`;
  }

  const cartButton = document.querySelector('.header__icon--cart');
  if (!bypassCartPage && cartButton) {
    cartButton.click();
    return;
  }

  // default localization does not need to be in URL
  if (Shopify.locale != 'en') {
    window.location.href = locale_root + "/" + cartUrl
    return
  }

  window.location.href = cartUrl;
}

// Adds a product to the users basket
function addItemToBasket(variantID, quantityToAdd, bypassCartPage) {
  if (parseInt(quantityToAdd, 10) != NaN) {
    quantityToAdd = parseInt(quantityToAdd, 10);
  }
  else {
    quantityToAdd = 1;
  }

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  let formData = new FormData();
  formData.append('quantity', quantityToAdd);
  formData.append('form_type', 'product');
  formData.append('id', variantID);

  // get any query string parameters, are we topping up an existing iccid?
  let parameters = {};
  // parameters.depart = document.getElementById('bundle-search-depart').value;
  // parameters.return = document.getElementById('bundle-search-return').value;   

  if (sessionStorage.getItem('topUpIccid')) {
    parameters.iccid = sessionStorage.getItem('topUpIccid');
    sessionStorage.removeItem('topUpIccid');
  }

  if (Shopify.locale !== null) {
    parameters.userLanguage = Shopify.locale;
  } else {
    parameters.userLanguage = 'en';
  }


  let checkoutUserAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (checkoutUserAgent) {
    parameters.userAgent = checkoutUserAgent;
  }

  if (deviceInfo) {
    parameters.deviceInfo = JSON.stringify(deviceInfo);
  }

  let tripDurationVal = sessionStorage.getItem('tripDuration')
  if (tripDurationVal > 0) {
    if (tripDurationVal == 1) {
      parameters.tripDuration = `${tripDurationVal} day`;
    }
    else {
      parameters.tripDuration = `${tripDurationVal} days`;
    }
  }

  // replaceCartWith clears the cookie once the add succeeds
  const chatbot = getChatbotAttribution();
  if (chatbot) {
    parameters.chatbot = chatbot;
  }

  // populate attributes from utils fn
  formData = populateCartAttributes(parameters, formData);

  config.body = formData;

  return clearCartAndCheckout(config, bypassCartPage);
}

function localisationSearch(listId, inputId){
  let countryList = document.getElementById(listId);
  
  if (countryList) {
    document.getElementById(inputId).addEventListener('input', function() {
        let filter = this.value.toLowerCase();
        Array.from(countryList.children).forEach(item => {
          if(item.textContent.toLocaleLowerCase().includes(filter)){
            item.style.display = '';
          } else {
            item.style.display = 'none';
          }
        })
    });
  }
}

function openCoverageModal(trigger) {
  const detail = {};
  if (trigger?.dataset?.modalHeading !== undefined) {
    const d = trigger.dataset;
    detail.copy = {
      modalHeading: d.modalHeading,
      modalSubheading: d.modalSubheading,
      modalSearchPlaceholder: d.modalSearchPlaceholder,
      modalNoResultsParagraph: d.modalNoResultsParagraph,
      modalNoResultsBoxedConetent: d.modalNoResultsBoxedContent,
      modalNoResultsButtonLabel: d.modalNoResultsButtonLabel,
    };
  }
  window.dispatchEvent(new CustomEvent('open-coverage-modal', { detail }));
}